/**************************************************************************************************/
/*   File: /src/app/shared/directives/file-upload/file-upload.directive.ts                        */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/

import {
  Directive,
  Input,
  ViewContainerRef,
  ElementRef,
  ComponentFactoryResolver,
  ReflectiveInjector,
  ComponentRef,
  Renderer2,
  ApplicationRef,
  EmbeddedViewRef,
  OnChanges,
  SimpleChanges,
  AfterContentInit
} from '@angular/core';
import { NumberComponent } from '../../components/number';

/**
 * The directive for file upload
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[wizardCard]'
})
export class WizardCardDirective implements AfterContentInit, OnChanges {

  /**
   * The number to show
   */
  @Input() ordinal: number;

  /**
   * The percentage number 
   */
  @Input() width: number;

  /**
   * Disabled condition
   */
  @Input() disabled: boolean;

  /**
   * Disabled condition
   */
  @Input() hidden: boolean;

  /**
   * Selected condition
   */
  @Input() selected: boolean;

  /**
   * The id of generated component
   */
  private _id = Math.floor(Math.random() * Math.pow(10, 6)).toString();

  /**
   * The component added
   */
  private componentRef: ComponentRef<NumberComponent>;

  /**
   * The constructor
   */
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private el: ElementRef,
    private appRef: ApplicationRef,
    private renderer: Renderer2) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(NumberComponent);
    // tslint:disable-next-line
    const injector = ReflectiveInjector.resolveAndCreate([]);
    this.componentRef = componentFactory.create(injector);
  }

  /**
   * The ng after content init life cycle hook
   */
  ngAfterContentInit(): void {

    /* istanbul ignore next */
    setTimeout(() => {

      if (!this.hidden) {
        const view = this.componentRef.hostView;
        this.appRef.attachView(view);
        const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>)
          .rootNodes[0] as HTMLElement;
        domElem.id = this._id;

        this.el.nativeElement.children[0].style.marginLeft = `${this.width * 100}%`;
        domElem.style.width = `${this.width * 100}%`;

        this.renderer.insertBefore(this.el.nativeElement, domElem, this.el.nativeElement.children[0]);
      }
    }, 0);
  }

  /**
   * The ng on changes life cycle hook
   * @param changes The simple changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.disabled) {
      this.componentRef.instance.disabled = changes.disabled.currentValue;
    }

    if (changes && changes.ordinal) {
      this.componentRef.instance.ordinal = changes.ordinal.currentValue;
    }

    if (changes && changes.selected) {
      this.componentRef.instance.selected = changes.selected.currentValue;
    }

    if (changes && changes.hidden) {

      if (changes.hidden.currentValue) {
        const el = document.getElementById(this._id);
        if (el) {
          /* istanbul ignore next */
          el.remove();
        }
        this.el.nativeElement.children[0].style.marginLeft = '0px';
      }
    }
  }

}
